import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setTreeField } from '../modules/tree/actions';

/**
 * Ersetzt das frühere TreeContext-Objekt eins zu eins (gleiche Feldnamen),
 * damit bestehende Konsumenten unverändert `tree.xxx`/`tree.setXxx(...)` nutzen können.
 *
 * Die Setter sind mit useCallback memoisiert, damit sie über Renders hinweg
 * referenzstabil bleiben - andernfalls loest jeder Aufruf von useTreeState() eine
 * neue Funktionsinstanz aus, was in einem useEffect mit z.B. `setItems` als
 * Dependency zu einer Endlosschleife fuehrt (setState -> Re-Render -> neue
 * Setter-Referenz -> Effekt feuert erneut -> setState -> ...).
 */
export function useTreeState() {
    const tree = useSelector((state) => state.tree);
    const dispatch = useDispatch();

    const setItems = useCallback((value) => dispatch(setTreeField('items', value)), [dispatch]);
    const setClicked = useCallback((value) => dispatch(setTreeField('clicked', value)), [dispatch]);
    const setIsLoaded = useCallback((value) => dispatch(setTreeField('isLoaded', value)), [dispatch]);
    const setSelected = useCallback((value) => dispatch(setTreeField('selected', value)), [dispatch]);
    const setSelectedItem = useCallback((value) => dispatch(setTreeField('selectedItem', value)), [dispatch]);
    const setParent = useCallback((value) => dispatch(setTreeField('parent', value)), [dispatch]);
    const setCatalogParentId = useCallback((value) => dispatch(setTreeField('catalogParentId', value)), [dispatch]);

    return {
        items: tree.items, setItems,
        clicked: tree.clicked, setClicked,
        isLoaded: tree.isLoaded, setIsLoaded,
        selected: tree.selected, setSelected,
        selectedItem: tree.selectedItem, setSelectedItem,
        parent: tree.parent, setParent,
        catalogParentId: tree.catalogParentId, setCatalogParentId,
    };
}
